import { render, staticRenderFns } from "./disposal.vue?vue&type=template&id=3a546330&scoped=true&"
import script from "./disposal.vue?vue&type=script&lang=js&"
export * from "./disposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a546330",
  null
  
)

export default component.exports